/**
 * Franja de edad en meses -> "0-6 months", "From 12 months", "Up to 6 months".
 * La BD la guarda en meses para poder filtrar; el texto se monta aqui.
 */
export const formatAgeRange = (t, min, max) => {
  if (min != null && max != null) return t("activityCard.ageRange", { min, max });
  if (min != null) return t("activityCard.ageFrom", { min });
  if (max != null) return t("activityCard.ageUpTo", { max });
  return "";
};

/**
 * Linea de informacion adicional de un elemento del catalogo, distinta segun el
 * tipo: la franja de edad de un objeto, la categoria de un soporte o la postura
 * generica de una postura. Los contexts no tienen.
 */
export const itemMeta = (t, kind, item) => {
  if (kind === "postures") return item.posture_group || "";
  if (kind !== "materials") return "";
  if (item.type === "object") {
    const age = formatAgeRange(t, item.age_min_months, item.age_max_months);
    return [t("activityCard.object"), age].filter(Boolean).join(" / ");
  }
  return [t("activityCard.support"), item.category].filter(Boolean).join(" / ");
};
